module.exports = "/images/display.svg?c01df88eca42107e441e8bf5c54ce078";